import type {
  OpsDayStatusApiData,
  OpsDayStatusApiResponses,
  OpsResolvedSignalListApiData,
  OpsResolvedSignalListApiResponses,
  OpsSignalListApiData,
  OpsSignalListApiResponses,
  OpsSignalPolicyListApiData,
  OpsSignalPolicyListApiResponses,
  OpsSignalPolicyResetApiData,
  OpsSignalPolicyResetApiResponses,
  OpsSignalPolicySetApiData,
  OpsSignalPolicySetApiResponses,
  OpsSignalResolutionCreateApiData,
  OpsSignalResolutionCreateApiResponses,
  OpsSignalResolutionDeleteApiData,
  OpsSignalResolutionDeleteApiResponses,
  OpsSignalSnoozeCreateApiData,
  OpsSignalSnoozeCreateApiResponses,
  OpsSignalSnoozeDeleteApiData,
  OpsSignalSnoozeDeleteApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getOpsUrls = {
  getOpsSignalPolicies: dataEndpoint<OpsSignalPolicyListApiData, OpsSignalPolicyListApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`ops/departments/${serviceDepartmentId}/policies/`)
  }),
  postOpsSignalPolicy: responseEndpoint<OpsSignalPolicySetApiData, OpsSignalPolicySetApiResponses>({
    getUrl: ({ serviceDepartmentId, kind }) => apiUrl(`ops/departments/${serviceDepartmentId}/policies/${kind}/`),
    getBody: (data) => data
  }),
  deleteOpsSignalPolicy: dataEndpoint<OpsSignalPolicyResetApiData, OpsSignalPolicyResetApiResponses>({
    getUrl: ({ serviceDepartmentId, kind }) => apiUrl(`ops/departments/${serviceDepartmentId}/policies/${kind}/`)
  }),
  postOpsSignalSnooze: responseEndpoint<OpsSignalSnoozeCreateApiData, OpsSignalSnoozeCreateApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`ops/departments/${serviceDepartmentId}/snoozes/`),
    getBody: (data) => data
  }),
  deleteOpsSignalSnooze: dataEndpoint<OpsSignalSnoozeDeleteApiData, OpsSignalSnoozeDeleteApiResponses>({
    getUrl: ({ snoozeId }) => apiUrl(`ops/snoozes/${snoozeId}/`)
  }),
  getOpsDayStatus: dataEndpoint<OpsDayStatusApiData, OpsDayStatusApiResponses>({
    getUrl: (queryParams) => apiUrl('ops/day-status/', queryParams)
  }),
  getOpsSignals: dataEndpoint<OpsSignalListApiData, OpsSignalListApiResponses>({
    getUrl: (queryParams) => apiUrl('ops/signals/', queryParams)
  }),
  getOpsResolvedSignals: dataEndpoint<OpsResolvedSignalListApiData, OpsResolvedSignalListApiResponses>({
    getUrl: (queryParams) => apiUrl('ops/resolved-signals/', queryParams)
  }),
  postOpsSignalResolution: responseEndpoint<OpsSignalResolutionCreateApiData, OpsSignalResolutionCreateApiResponses>({
    getUrl: () => apiUrl('ops/signal-resolutions/'),
    getBody: (data) => data
  }),
  deleteOpsSignalResolution: dataEndpoint<OpsSignalResolutionDeleteApiData, OpsSignalResolutionDeleteApiResponses>({
    getUrl: ({ resolutionId }) => apiUrl(`ops/signal-resolutions/${resolutionId}/`)
  })
};
